(() => {
  const media = matchMedia('(min-width:900px) and (prefers-reduced-motion:no-preference)');
  const bind = (scope = document) => scope.querySelectorAll('.dap-shoppable-room').forEach(section => {
    if (section.dataset.storyBound || !('IntersectionObserver' in window)) return;
    section.dataset.storyBound = 'true';
    const scene = section.querySelector('.dap-room-scene');
    const skip = section.querySelector('[data-room-story-skip]');
    let active = false, frame = 0, finished = false;
    const complete = () => { finished = true; section.style.setProperty('--room-progress', '1'); section.dataset.roomRevealed = 'true'; skip.hidden = true; };
    const update = () => {
      frame = 0;
      if (!media.matches || finished) return;
      const top = scene.getBoundingClientRect().top;
      const progress = Math.max(0, Math.min(1, (innerHeight * .95 - top) / (innerHeight * .65)));
      section.style.setProperty('--room-progress', progress.toFixed(4));
      section.dataset.roomRevealed = String(progress >= .995);
      if (progress >= .995) complete();
    };
    const scroll = () => { if (active && !finished && !frame) frame = requestAnimationFrame(update); };
    const configure = () => {
      section.classList.toggle('dap-room-story', media.matches);
      finished = !media.matches;
      skip.hidden = !media.matches;
      if (!media.matches) { section.style.removeProperty('--room-progress'); section.dataset.roomRevealed = 'true'; }
      else update();
    };
    const observer = new IntersectionObserver(entries => { active = entries[0].isIntersecting; if (active) scroll(); }, {rootMargin:'200px'});
    observer.observe(scene);
    window.addEventListener('scroll', scroll, {passive:true});
    window.addEventListener('resize', scroll, {passive:true});
    media.addEventListener('change', configure);
    skip.addEventListener('click', () => { complete(); section.querySelector('.dap-room-marker summary')?.focus({preventScroll:true}); });
    section.addEventListener('focusin', event => { if (!skip.contains(event.target)) complete(); });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(section)) { observer.disconnect(); window.removeEventListener('scroll', scroll); window.removeEventListener('resize', scroll); media.removeEventListener('change', configure); cancelAnimationFrame(frame); } });
    configure();
  });
  bind(); document.addEventListener('shopify:section:load', e => bind(e.target));
})();
